const s = "118.6.0", e = "9.54.0";
export {
  s as designSystemVersion,
  e as designTokensVersion
};
